/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('hrPlanningCtrl', ["$log", "$scope", "SiteData", "$timeout", "PlanningTableView",
    function ($log, $scope, SiteData, $timeout, PlanningTableView) {
        $scope.$watch('ad.sDm', function (newValue, oldValue) {
            if (newValue == 'planning') {
                // INIT VIEW
                $scope.loadPTView();
            }
        });

        var doit;
        window.onresize = function () {
            clearTimeout(doit);
            doit = setTimeout($scope.onWindowResizeEnd, 500);
        };
        $scope.onWindowResizeEnd = function () {
            if ($scope.dd.view && $scope.dd.view.pTView) {
                $scope.dd.view.pTView.updateSize($scope.getPlanningLeft(), $scope.getPlanningTop(), $scope.getPlanningWidth(), $scope.getPlanningHeight());
                $scope.$apply();
            }
        };

        $scope.loadPTView = function () {
            $timeout(function () // Assychron load to display waiting spinner
            {
                console.log($scope.dd.view.humanResourcesView);
                $scope.dd.view.humanResourcesView = [];
                var nbHrMax = $scope.dd.view.humanResourcesActiveView.length;
                if ($scope.ad.addons.sub.solo)
                    nbHrMax = 1;
                var nbHr = 0;
                for (var i = 0; i < $scope.dd.view.humanResourcesActiveView.length && nbHr < nbHrMax; i++) {
                    if ($scope.dd.view.humanResourcesActiveView[i].hasPlanning) {
                        $scope.dd.view.humanResourcesView.push($scope.dd.view.humanResourcesActiveView[i]);   // planning actived
                        nbHr++;
                    }
                }
                $scope.dd.view.scope = $scope;
                $scope.dd.view.getHrView = function (hr) {
                    for (var i = 0; i < this.humanResourcesActiveView.length; i++)
                        if (this.humanResourcesActiveView[i].getModel() === hr)
                            return this.humanResourcesActiveView[i];
                    for (i = 0; i < this.humanResourcesDeletedView.length; i++)
                        if (this.humanResourcesDeletedView[i].getModel() === hr)
                            return this.humanResourcesDeletedView[i];
                    return null;
                };
                $scope.dd.view.getNbVisibleHr = function () {
                    return $scope.dd.view.humanResourcesView.length;
                };
                $scope.dd.view.getHumanResourcesView = function () {
                    return $scope.dd.view.humanResourcesView;
                };

                $scope.dd.view.pTView = new PlanningTableView(
                    true, true,
                    $scope.getPlanningLeft(),
                    $scope.getPlanningTop(),
                    $scope.getPlanningWidth(),
                    $scope.getPlanningHeight(),
                    null,
                    $scope.dd.view, false);

                $scope.dd.loading = false;
            }, 100);
        };
        $scope.$watch('dd.view.pTView.dim.nbDays', function (newValue, oldValue) {
            if ($scope.dd.view && $scope.dd.view.pTView && $scope.dd.view.pTView instanceof PlanningTableView && oldValue !== undefined && !$scope.dd.view.pTView.loading) {
                $scope.dd.view.pTView.initPlgDaysViewOnStandardWeek();
            }
        });
        $scope.getPlanningLeft = function () {
            let planningStart = 0;

            let cfgMenuWidth = angular.element('#cfg-menu').css('width');
            let posMenuWidth = angular.element('#pos-menu').css('width');
            let menuWidthStr = '';

            if (cfgMenuWidth) {
                menuWidthStr = cfgMenuWidth;
            } else if (posMenuWidth) {
                menuWidthStr = posMenuWidth;
            }

            if (menuWidthStr) {
                menuWidthStr = menuWidthStr.replace("px");
                planningStart = parseInt(menuWidthStr);
            }

            return planningStart;
        };
        $scope.getPlanningTop = function () {
            return 136;//menu + table titles

        };
        $scope.getPlanningWidth = function () {
            let bodyWidth = $scope.getDomainWidth();

            if ($scope.dd.isStandardWeek) {
                let menuLeft = $scope.getPlanningLeft();
                if (menuLeft) {
                    bodyWidth -= menuLeft;
                }
            }

            return bodyWidth;
        };
        $scope.getPlanningHeight = function () {
            var planningHeightStr = angular.element('body').css('height');
            if (planningHeightStr == null)
                return 0;
            var planningHeight = parseInt(planningHeightStr.replace("px"));
            planningHeight -= $scope.getPlanningTop();//menu + action barre + table titles
            return planningHeight;
        };


        $scope.getDomainWidth = function () {
            var bodyWidthStr = angular.element('body').css('width');
            bodyWidthStr = bodyWidthStr.replace("px");
            return parseInt(bodyWidthStr);
        };
    }]);



// WEBPACK FOOTER //
// ./js/controllers/pro/configuration/hr/hrPlanningCtrl.js